export default __webpack_public_path__ + "static/media/django.caf540cd.svg";